import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';
import Modal from '../../common/Modal';
import './index.scss';


const ConfirmacionReciboModal = (props) => {

  const [usarCreditos, setUsarCreditos] = useState(true);

  return (

    <Modal
      size="md"
      className="confirmacion-recibo-modal"
      title={props.title}
      onEscape={() => props.onDismiss()}
      body={props.message && (
          <div className="confirmacion-recibo-body">
            <p className="confirmacion-recibo-pregunta">{props.message}</p>
            {props.showCreditos &&
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="usarCreditos"
                  checked={usarCreditos}
                  onChange={({target}) => setUsarCreditos(target.checked)}
                />
                <label className="form-check-label" htmlFor="usarCreditos">{props.labelCreditos}</label>
              </div>
            }
          </div>
      )}
      footerClassName="confirmacion-recibo-footer"
      footer={(<>
            <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
            <div className="confirmacion-recibo-acciones">
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onConfirm({ reciboResumido: true, usarCreditos: props.showCreditos && usarCreditos }) }>{props.confirmLabel} resumido</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => props.onConfirm({ reciboResumido: false, usarCreditos: props.showCreditos && usarCreditos }) }>{props.confirmLabel}</button>
            </div>
      </>)}
    />

  );
}

ConfirmacionReciboModal.propTypes = {
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  title: string,
  message: string,
  confirmLabel: string,
  showCreditos: bool,
  labelCreditos: string
};

ConfirmacionReciboModal.defaultProps = {
  title: "",
  message: "",
  confirmLabel: "Confirmar",
  showCreditos: false,
  labelCreditos: "Usar créditos"
};

export default ConfirmacionReciboModal;
